import { makeStyles, tokens, shorthands } from "@fluentui/react-components";

const novataNavy = "#02344D";
const novataNavyDark = "#00344D";
const novataTeal = "#008099";
const novataLime = "#D8E94B";
const novataLimeHover = "#C7D93C";
const inter = `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif`;

export const useLoginStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "stretch",
    minHeight: "100vh",
    backgroundColor: "#ffffff",
    padding: 0,
    boxSizing: "border-box",
    fontFamily: inter,
  },
  card: {
    width: "100%",
    maxWidth: "480px",
    backgroundColor: "#ffffff",
    boxShadow: "none",
    ...shorthands.borderRadius(0),
    ...shorthands.border(0),
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    ...shorthands.padding(0),
    ...shorthands.gap(0),
  },
  hero: {
    backgroundColor: novataNavy,
    color: "#ffffff",
    padding: "40px 32px 56px 32px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "32px",
    position: "relative",
    overflow: "hidden",
  },
  heroLogo: {
    width: "96px",
    height: "auto",
    "& img": {
      width: "100%",
      height: "auto",
      display: "block",
      filter: "brightness(0) invert(1)",
    },
  },
  heroTitle: {
    margin: 0,
    color: "#ffffff",
    fontFamily: inter,
    fontWeight: 200,
    fontSize: "32px",
    lineHeight: "1.15",
    letterSpacing: "-0.01em",
  },
  heroAccent: {
    position: "relative",
    width: "100%",
    height: "60px",
    marginTop: "8px",
    pointerEvents: "none",
  },
  heroDotLine: {
    position: "absolute",
    height: "1.5px",
    backgroundColor: novataTeal,
    display: "block",
    "&:nth-child(1)": { top: "8px" },
    "&:nth-child(2)": { top: "20px" },
    "&:nth-child(3)": { top: "32px" },
    "&:nth-child(4)": { top: "44px" },
    "&:nth-child(5)": { top: "54px" },
    "&::after": {
      content: '""',
      position: "absolute",
      right: "-4px",
      top: "-3px",
      width: "8px",
      height: "8px",
      ...shorthands.borderRadius("50%"),
      backgroundColor: novataLime,
    },
    "&:nth-child(2)::after, &:nth-child(4)::after": {
      backgroundColor: novataTeal,
    },
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    width: "100%",
    boxSizing: "border-box",
    padding: "40px 32px 32px 32px",
    backgroundColor: "#ffffff",
  },
  title: {
    margin: 0,
    fontFamily: inter,
    fontSize: "26px",
    fontWeight: 300,
    color: novataNavyDark,
    marginBottom: "32px",
    lineHeight: "1.2",
  },
  dropdownContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    marginBottom: "20px",
  },
  dropdownLabel: {
    fontFamily: inter,
    fontSize: "13px",
    fontWeight: 600,
    color: novataNavyDark,
  },
  dropdown: {
    width: "100%",
    minWidth: 0,
    fontFamily: inter,
  },
  button: {
    width: "100%",
    height: "44px",
    fontFamily: inter,
    fontWeight: 600,
    fontSize: "15px",
    color: novataNavyDark,
    backgroundColor: novataLime,
    ...shorthands.border("1px", "solid", novataLime),
    ...shorthands.borderRadius("4px"),
    transition: "background-color 120ms ease, border-color 120ms ease",
    "&:hover": {
      backgroundColor: novataLimeHover,
      ...shorthands.borderColor(novataLimeHover),
      color: novataNavyDark,
    },
    "&:hover:active": {
      backgroundColor: novataLimeHover,
      ...shorthands.borderColor(novataLimeHover),
      color: novataNavyDark,
    },
    "&:disabled, &[disabled]": {
      backgroundColor: "#E8EFC4",
      ...shorthands.borderColor("#E8EFC4"),
      color: "#7A8A4F",
    },
  },
  helpLink: {
    display: "inline-block",
    marginTop: "16px",
    fontFamily: inter,
    fontSize: "14px",
    color: novataNavyDark,
    textDecorationLine: "underline",
    alignSelf: "flex-start",
    "&:hover": {
      color: novataTeal,
    },
  },
  loadingText: {
    marginTop: "16px",
    fontSize: "13px",
    fontFamily: inter,
    color: tokens.colorNeutralForeground3,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: tokens.spacingHorizontalS,
    width: "100%",
  },
  errorText: {
    marginTop: "16px",
    width: "100%",
    fontFamily: inter,
  },
  helpText: {
    marginTop: "8px",
    fontSize: "12px",
  },
  helpList: {
    margin: "4px 0 0 16px",
    padding: 0,
  },
});
